import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Import Swiper React components and required styles
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import "./ServicePrepHeader.css";
import BreadcrumbNav from "../../common_components/breadcrumbNav/BreadcrumbNav";
import HighlightServicesCard from "../../common_components/highlightServicesCard/HighlightServicesCard";

function ServicePrepHeader() {
  const categoryTabsData = [
    {
      id: 1,
      title: "Interview Preparation",
      icon: "/assets/Images/career_solutions/HighlightServices/interview-preparation.svg",
      link: "/career-solutions",
    },
  ];

  const breadcrumbPaths = [
    { label: "Home", url: "/" },
    { label: "Services", url: "/career-services" },
  ];

  return (
    <div className="expert-services-header-parent">
      <Container className="py-4">
        <BreadcrumbNav items={breadcrumbPaths} />
        <Row className="align-items-center g-4">
          {/* Left Text Column */}
          <Col lg={5} md={12}>
            <div className="content-left-block">
              <h1 className="main-title">Prep</h1>
              <p className="description-text">
                Get your own rehearsal space to prep and ace every interview
                that comes your way
              </p>
            </div>
          </Col>

          {/* Right Column with Swiper Slider */}
          <Col lg={7} md={12}>
            <div className="swiper-container-wrapper">
              <Swiper
                spaceBetween={20}
                slidesPerView={2}
                breakpoints={{
                  // Responsive grid view matching desktop layouts
                  576: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                }}
                className="category-swiper"
              >
                {categoryTabsData.map((category) => (
                  <SwiperSlide
                    key={category.id}
                    className="d-flex justify-content-center py-2"
                  >
                    <HighlightServicesCard
                      title={category.title}
                      icon={category.icon}
                      link={category.link}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ServicePrepHeader;
